export const WIDTH = 519
export const HEIGHT = 272

export const PI = Math.PI
export const TWO_PI = Math.PI * 2
export const HALF_PI = Math.PI / 2

export const FONT_FAMILY = "'M PLUS 1p', sans-serif"

export const COLOR_TRANSPARENT = 'transparent'
export const COLOR_BLACK = '#000000'
export const COLOR_WHITE = '#FFFFFF'
export const COLOR_GRAY_100 = '#F7FAFC'
export const COLOR_GRAY_200 = '#EDF2F7'
export const COLOR_GRAY_300 = '#E2E8F0'
export const COLOR_GRAY_400 = '#CBD5E0'
export const COLOR_GRAY_500 = '#A0AEC0'
export const COLOR_GRAY_600 = '#718096'
export const COLOR_GRAY_700 = '#4A5568'
export const COLOR_GRAY_800 = '#2D3748'
export const COLOR_GRAY_900 = '#1A202C'
export const COLOR_RED_100 = '#FFF5F5'
export const COLOR_RED_200 = '#FED7D7'
export const COLOR_RED_300 = '#FEB2B2'
export const COLOR_RED_400 = '#FC8181'
export const COLOR_RED_500 = '#F56565'
export const COLOR_RED_600 = '#E53E3E'
export const COLOR_RED_700 = '#C53030'
export const COLOR_RED_800 = '#9B2C2C'
export const COLOR_RED_900 = '#742A2A'
export const COLOR_ORANGE_100 = '#FFFAF0'
export const COLOR_ORANGE_200 = '#FEEBC8'
export const COLOR_ORANGE_300 = '#FBD38D'
export const COLOR_ORANGE_400 = '#F6AD55'
export const COLOR_ORANGE_500 = '#ED8936'
export const COLOR_ORANGE_600 = '#DD6B20'
export const COLOR_ORANGE_700 = '#C05621'
export const COLOR_ORANGE_800 = '#9C4221'
export const COLOR_ORANGE_900 = '#7B341E'
export const COLOR_YELLOW_100 = '#FFFFF0'
export const COLOR_YELLOW_200 = '#FEFCBF'
export const COLOR_YELLOW_300 = '#FAF089'
export const COLOR_YELLOW_400 = '#F6E05E'
export const COLOR_YELLOW_500 = '#ECC94B'
export const COLOR_YELLOW_600 = '#D69E2E'
export const COLOR_YELLOW_700 = '#B7791F'
export const COLOR_YELLOW_800 = '#975A16'
export const COLOR_YELLOW_900 = '#744210'
export const COLOR_GREEN_100 = '#F0FFF4'
export const COLOR_GREEN_200 = '#C6F6D5'
export const COLOR_GREEN_300 = '#9AE6B4'
export const COLOR_GREEN_400 = '#68D391'
export const COLOR_GREEN_500 = '#48BB78'
export const COLOR_GREEN_600 = '#38A169'
export const COLOR_GREEN_700 = '#2F855A'
export const COLOR_GREEN_800 = '#276749'
export const COLOR_GREEN_900 = '#22543D'
export const COLOR_TEAL_100 = '#E6FFFA'
export const COLOR_TEAL_200 = '#B2F5EA'
export const COLOR_TEAL_300 = '#81E6D9'
export const COLOR_TEAL_400 = '#4FD1C5'
export const COLOR_TEAL_500 = '#38B2AC'
export const COLOR_TEAL_600 = '#319795'
export const COLOR_TEAL_700 = '#2C7A7B'
export const COLOR_TEAL_800 = '#285E61'
export const COLOR_TEAL_900 = '#234E52'
export const COLOR_BLUE_100 = '#EBF8FF'
export const COLOR_BLUE_200 = '#BEE3F8'
export const COLOR_BLUE_300 = '#90CDF4'
export const COLOR_BLUE_400 = '#63B3ED'
export const COLOR_BLUE_500 = '#4299E1'
export const COLOR_BLUE_600 = '#3182CE'
export const COLOR_BLUE_700 = '#2B6CB0'
export const COLOR_BLUE_800 = '#2C5282'
export const COLOR_BLUE_900 = '#2A4365'
export const COLOR_INDIGO_100 = '#EBF4FF'
export const COLOR_INDIGO_200 = '#C3DAFE'
export const COLOR_INDIGO_300 = '#A3BFFA'
export const COLOR_INDIGO_400 = '#7F9CF5'
export const COLOR_INDIGO_500 = '#667EEA'
export const COLOR_INDIGO_600 = '#5A67D8'
export const COLOR_INDIGO_700 = '#4C51BF'
export const COLOR_INDIGO_800 = '#434190'
export const COLOR_INDIGO_900 = '#3C366B'
export const COLOR_PURPLE_100 = '#FAF5FF'
export const COLOR_PURPLE_200 = '#E9D8FD'
export const COLOR_PURPLE_300 = '#D6BCFA'
export const COLOR_PURPLE_400 = '#B794F4'
export const COLOR_PURPLE_500 = '#9F7AEA'
export const COLOR_PURPLE_600 = '#805AD5'
export const COLOR_PURPLE_700 = '#6B46C1'
export const COLOR_PURPLE_800 = '#553C9A'
export const COLOR_PURPLE_900 = '#44337A'
export const COLOR_PINK_100 = '#FFF5F7'
export const COLOR_PINK_200 = '#FED7E2'
export const COLOR_PINK_300 = '#FBB6CE'
export const COLOR_PINK_400 = '#F687B3'
export const COLOR_PINK_500 = '#ED64A6'
export const COLOR_PINK_600 = '#D53F8C'
export const COLOR_PINK_700 = '#B83280'
export const COLOR_PINK_800 = '#97266D'
export const COLOR_PINK_900 = '#702459'

export const FONT_WEIGHT_BOLD = 'bold'
export const FONT_WEIGHT_NORMAL = 'normal'

export const TEXT_ALIGN_START = 'start'
export const TEXT_ALIGN_END = 'end'
export const TEXT_ALIGN_RIGHT = 'right'
export const TEXT_ALIGN_LEFT = 'left'
export const TEXT_ALIGN_CENTER = 'center'

export const BACKGROUND_COLOR = COLOR_GREEN_600

export const CARD_COLOR = COLOR_WHITE
export const CARD_MARGIN = 8
export const CARD_WIDTH = WIDTH - CARD_MARGIN * 2
export const CARD_HEIGHT = HEIGHT - CARD_MARGIN * 2
export const CARD_RADIUS = 20
export const CARD_X = CARD_MARGIN
export const CARD_Y = CARD_MARGIN

export const USER_ICON_X = 30
export const USER_ICON_Y = 30
export const USER_ICON_SIZE = 50

export const USER_DISPLAY_NAME_FONT_SIZE = 14
export const USER_DISPLAY_NAME_X = WIDTH - 28
export const USER_DISPLAY_NAME_Y = HEIGHT - 28
export const USER_DISPLAY_NAME_WIDTH = 100
export const USER_DISPLAY_NAME_COLOR = COLOR_GRAY_900
export const USER_DISPLAY_NAME_TEXT_ALIGN = TEXT_ALIGN_RIGHT
export const USER_DISPLAY_NAME_FONT = `${FONT_WEIGHT_NORMAL} ${USER_DISPLAY_NAME_FONT_SIZE}px ${FONT_FAMILY}`

export const QUESTION_BODY_BASE_X = WIDTH / 2
export const QUESTION_BODY_BASE_Y = 60
export const QUESTION_BODY_WIDTH = 463
export const QUESTION_BODY_HEIGHT = 192
export const QUESTION_BODY_MAX_LINES_LENGTH = 5
export const QUESTION_BODY_LINE_GUTTER = 8
export const QUESTION_BODY_FONT_SIZE = 32
export const QUESTION_BODY_COLOR = COLOR_BLACK
export const QUESTION_BODY_TEXT_ALIGN = TEXT_ALIGN_CENTER
export const QUESTION_BODY_FONT = `${FONT_WEIGHT_BOLD} ${QUESTION_BODY_FONT_SIZE}px ${FONT_FAMILY}`

export const QUESTION_SUB_BODY_BASE_X = 28
export const QUESTION_SUB_BODY_BASE_Y = HEIGHT - 28
export const QUESTION_SUB_BODY_WIDTH = 350
export const QUESTION_SUB_BODY_FONT_SIZE = 14
export const QUESTION_SUB_BODY_TEXT_ALIGN = TEXT_ALIGN_LEFT
export const QUESTION_SUB_BODY_COLOR = COLOR_BLACK
export const QUESTION_SUB_BODY_FONT = `${FONT_WEIGHT_NORMAL} ${QUESTION_SUB_BODY_FONT_SIZE}px ${FONT_FAMILY}`
export const QUESTION_SUB_BODY_MAX_LINES_LENGTH = 1
export const QUESTION_SUB_BODY_LINE_GUTTER = QUESTION_SUB_BODY_FONT_SIZE * 0.25

export const ANSWER_BODY_BASE_X = WIDTH / 2
export const ANSWER_BODY_BASE_Y = 60
export const ANSWER_BODY_WIDTH = 463
export const ANSWER_BODY_HEIGHT = 192
export const ANSWER_BODY_MAX_LINES_LENGTH = 5
export const ANSWER_BODY_LINE_GUTTER = 8
export const ANSWER_BODY_FONT_SIZE = 32
export const ANSWER_BODY_COLOR = COLOR_BLACK
export const ANSWER_BODY_TEXT_ALIGN = TEXT_ALIGN_CENTER
export const ANSWER_BODY_FONT = `${FONT_WEIGHT_BOLD} ${ANSWER_BODY_FONT_SIZE}px ${FONT_FAMILY}`
